import {getAll} from "@/api/workplace.js"
import {getAll as getAllRoomType} from "@/api/roomtype.js"
import {formitemhandle,formfn} from './formfn'

let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)

/**
 * 增删改查
 */
const curdfn = {
	addht(showModal){
		this.formData = {
			cmpid:user.cmpid,
			datainfo:[
				{
					key:(new Date()).getTime(),
					room:{type:undefined,num:"",price:"",sum:""},
					price:{type:undefined,num:"",price:"",sum:""},
					butie:{note:"",num:''},
					kouchu:{note:"",num:''},
					workplace:""
				},
			],
		}
		showModal("添加包工合同",[
			{"value":"name","text":"姓名"}
		],"700px")
	},
		// 行末删除修改操作
	updateBGhetong(record,showModal){
		this.formData = record
		showModal("修改包工合同",[
			{"value":"idcard","text":"身份证号"}
		],"700px")
	},
	deletBGhetong(record,showDelConfirm){
		this.formData = {...record}
		showDelConfirm()
	},
	getDetialData(record){
		return ()=>{
			let {datainfo} = record
			datainfo = datainfo.map(item=>{
				console.log(item)
				let {workplace,
					price:{type:type1,price:price1,num:num1,sum:sum1},
					room:{type:type2,price:price2,num:num2,sum:sum2},
					butie:{note:note3,num:num3},
					kouchu:{note:note4,num:num4}} = item
				return {workplace:this.workplaceshow(workplace),
					type1:this.moneytypeshow(type1),price1,num1,sum1,
					type2:this.moneytypeshow(type2),price2,num2,sum2,
					note3,num3,
					note4,num4,
				}
			})
			return Promise.resolve(datainfo)
		}
	}
}

/**
 * 其他函数
 */
const commenfn ={
	getworkpalceArrary(){
		getAll({cmpid:user.cmpid}).then(ret=>{
			if(ret.code == 0){
				let {data} = ret
				this.workplaceArray = data
			}
		})
	},
	getroomtypeArray(){
		getAllRoomType({cmpid:user.cmpid}).then(ret=>{
			if(ret.code == 0){
				let {data} = ret
				this.roomtypeArray = data
			}
		})
	},
	changecolor(record){
		let {shifoufafang} = record
		if(shifoufafang == 1){
			return "bianhong"
		}
		return ""
	},
	
	//表格数据处理函数
	worktypeshow(id){
		let worktypes =  {
			// 1:点工 2:带班 3:班组(包工)
			"1":"点工",
			"2":"带班",
			"3":"班组(包工）",
		}
		return worktypes[id]
	},
	workplaceshow(id){
		let wp = this.workplaceArray.find(item=>item.id == id)
		if(wp){
			return wp["name"]
		}else{
			return  ""
		}
	},
	roomtypeshow(id){
		let rt = this.roomtypeArray.find(item=>item.id == id)
		if(rt){
			return rt["name"]
		}else{
			return  ""
		}
	},
	moneytypeshow(id){
		let types = ["","男大工","男小工","女小工"]
		if(types[id]){
			return types[id]
		}else{
			return ""
		}
	}
}

export default {
	...formitemhandle,
	...formfn,
	...curdfn,
	...commenfn
}